var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.89 12.25C36.5876 11.7261 36.1546 11.2895 35.6332 10.9828C35.1118 10.6761 34.5198 10.5098 33.915 10.5H11.515L10.5 6.54505C10.3974 6.16327 10.1687 5.82745 9.85088 5.5923C9.53311 5.35715 9.14508 5.23652 8.75 5.25005H5.25C4.78587 5.25005 4.34075 5.43442 4.01256 5.76261C3.68437 6.0908 3.5 6.53592 3.5 7.00005C3.5 7.46418 3.68437 7.9093 4.01256 8.23749C4.34075 8.56568 4.78587 8.75005 5.25 8.75005H7.42L12.25 26.705C12.3525 27.0868 12.5813 27.4226 12.8991 27.6578C13.2169 27.893 13.6049 28.0136 14 28H29.75C30.0732 27.9991 30.3898 27.9086 30.6647 27.7387C30.9396 27.5688 31.1621 27.3261 31.3075 27.0375L37.0475 15.5576C37.2963 15.0361 37.4121 14.4611 37.3846 13.884C37.3571 13.3069 37.1872 12.7455 36.89 12.25ZM28.665 24.5H15.33L12.4775 14H33.915L28.665 24.5Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 36.75C14.5747 36.75 15.75 35.5747 15.75 34.125C15.75 32.6753 14.5747 31.5 13.125 31.5C11.6753 31.5 10.5 32.6753 10.5 34.125C10.5 35.5747 11.6753 36.75 13.125 36.75Z",
    fill: "#CECECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 36.75C32.0747 36.75 33.25 35.5747 33.25 34.125C33.25 32.6753 32.0747 31.5 30.625 31.5C29.1753 31.5 28 32.6753 28 34.125C28 35.5747 29.1753 36.75 30.625 36.75Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopings);
export default __webpack_public_path__ + "static/media/Shopings.a2457553b8030387465c68ca0911b4de.svg";
export { ForwardRef as ReactComponent };